import { render, staticRenderFns } from "./SuggestOnlyStatusInProgress.vue?vue&type=template&id=466cb21a&"
import script from "./SuggestOnlyStatusInProgress.vue?vue&type=script&lang=js&"
export * from "./SuggestOnlyStatusInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports